import { RootState } from '@redux/types';

export const waitingServiceWorkerSelector = (state: RootState): ServiceWorker | null =>
  state.serviceWorker.waitingServiceWorker;
